import 'slick-carousel/slick/slick.min';
import '@fancyapps/fancybox/dist/jquery.fancybox.min';
import Modernizr from 'modernizr';
import LazyLoad from "vanilla-lazyload";


export default class Utils {
    constructor() {
        Utils.click();
        Utils.tooltip();
        Utils.fancybox();
        Utils.searchbox();
        Utils.smooth_scroll();
        Utils.lazy();
        Utils.initialize_sticky_nav();
        Utils.dynamic_tab();
        Utils.fade_backtotop();
        Utils.initialize_instagram();
        Utils.initialize_burger_menu();
    }

    static click() {

        const trigger = '[data-trigger="wpiris-click"]';

        if (!Modernizr.touchevents) {
            let ctrl = 0;
            $(window).on('keydown', function (e) {
                if (e.which == 17 || e.which == 91) {
                    ctrl = true
                }
            })
            $(window).on('keyup', function () {
                ctrl = false
            })

            $(document).on('mouseup', trigger, function (e) {

                if (e.which == 1 || e.which == 2) {
                    let blank = false
                    let url = $(this).find("a").attr("href")
                    if (e.which == 2) {
                        blank = true
                    } // Clic molette
                    if ($(this).find("a").attr("target") == "_blank") {
                        blank = true
                    }
                    if (blank || ctrl) {
                        window.open(url, '_blank')
                    } else {
                        window.location = url
                    }
                    return false
                }
                return false

            })
        } else {
            $(document).on('click', trigger, function (e) {

                let blank = false
                let url = $(this).find("a").attr("href")
                if ($(this).find("a").attr("target") == "_blank") {
                    blank = true
                }
                if (blank) {
                    window.open(url, '_blank')
                } else {
                    window.location = url
                }
                return false

            })
        }
    }

    static tooltip() {
        if (!Modernizr.touchevents) {
            $('[data-toggle="tooltip"]').tooltip({trigger: "hover"})
        }
    }

    static fancybox() {

        $('.hentry a:has(>img):not([target="_blank"]):not("[nofancybox]")').attr('data-fancybox', 'fancybox')

        $('[data-fancybox="fancybox"]').fancybox({
            buttons: [
                "zoom",
                "slideShow",
                "close"
            ],
            lang: "fr",
            i18n: {
                fr: {
                    CLOSE: Theme.translate.fancyboxClose,
                    NEXT: Theme.translate.fancyboxNext,
                    PREV: Theme.translate.fancyboxPrev,
                    ERROR: Theme.translate.fancyboxError,
                    PLAY_START: Theme.translate.fancyboxStart,
                    PLAY_STOP: Theme.translate.fancyboxStop,
                    FULL_SCREEN: Theme.translate.fancyboxFullScreen,
                    THUMBS: Theme.translate.fancyboxThumbs,
                    DOWNLOAD: Theme.translate.fancyboxDownload,
                    SHARE: Theme.translate.fancyboxShare,
                    ZOOM: Theme.translate.fancyboxZoom
                },
            },
            caption: function (instance, item) {
                let caption = $(this).closest('figure').find('figcaption').html()

                if (!caption) {
                    caption = $(this).find('img').attr('title')
                }

                if (!caption) {
                    caption = $(this).find('img').attr('alt')
                }

                return caption
            }
        })
    }

    static searchbox() {
        const trigger = '[data-trigger="wpiris-search-layout"]',
            close = '[data-trigger="wpiris-search-layout-close"]',
            $element = $('[data-id="wpiris-search-layout"]');

        $(document).on('click', trigger, function (e) {
            e.preventDefault();
            $element.fadeIn().find('input').focus();
        })

        $(document).on('click', close, function (e) {
            e.preventDefault();
            $element.fadeOut();
        })
    }

    static smooth_scroll() {
        const trigger = '[data-trigger="wpiris-scroll"]';

        $(document).on('click', trigger, function (e) {
            e.preventDefault();

            const target = $(this).attr("href") != '' ? $(this).attr("href") : $(this).attr("data-href");
            const duration = 1000;

            if  (window.matchMedia("(max-width: 650px)").matches && $('html').find('.single-wpet-mobile')){
                $('html, body').animate({
                    scrollTop: $(target).offset().top - 80
                }, duration);
            } else {
                $('html, body').animate({
                    scrollTop: $(target).offset().top
                }, duration);
            }
        })
    }

    static lazy() {
        let lazyLoadInstance = new LazyLoad({
            elements_selector: '[data-src], [data-bg]'
        });
    }

    /* Sticky nav
   /* ============================================= */
    static initialize_sticky_nav()
    {
        let last_scroll_top = 0;
        const logo = '[data-id="wpiris-logo"]',
              logo_src = $(logo).attr("src"),
              pathname = window.location.pathname;

        var pathname_parse = pathname.split('/');

        $( window ).on( 'load scroll', function () {

            let scroll_top = $( this ).scrollTop();
            let $header    = $( '.navbar' );

            if ( scroll_top >= last_scroll_top && scroll_top > $header.outerHeight() ) {
                // Down
                $( 'body' ).addClass( 'header-is-hidden' );
            } else {
                // Up
                $( 'body' ).removeClass( 'header-is-hidden' );
            }

            last_scroll_top = scroll_top;

            if ( scroll_top > $header.outerHeight() ) {
                // Down
                $( 'body' ).addClass( 'nav-is-white' );
                if (pathname_parse[1] == "groupes") {
                    $(logo).attr("src", Theme.themeURL + "/assets/dist/images/logo-groupe.svg");
                } else if(pathname_parse[1] == "pro") {
                    $(logo).attr("src", Theme.themeURL + "/assets/dist/images/logo-pro.svg");
                } else {
                    $(logo).attr("src", Theme.themeURL + "/assets/dist/images/logo.svg");
                }
            } else {
                // Up
                $( 'body' ).removeClass( 'nav-is-white' );
                $(logo).attr("src", logo_src);
            }
        } );
    }

    /* Page contact content tab
   /* ============================================= */
    static dynamic_tab()
    {
        const trigger_module = '[data-trigger="wpiris-trigger-module"]',
            trigger_item = '[data-trigger="wpiris-trigger-item"]';
        $( document ).on( 'click', trigger_module, function ( e ) {
            e.preventDefault();
            const that = $(this),
                tab  = that.attr('href');

            if ( !that.hasClass('is-active') ) {
                $(trigger_module).removeClass('is-active');
                that.addClass('is-active');
                $(trigger_item).hide().removeClass('is-active');
                $(tab).fadeIn().addClass('is-active');
            }
        });
    }

    /* back to top animation button
    /* ============================================= */
    static fade_backtotop()
    {
        const wpiris_fade = '[data-backtotop="wpiris-fade"]';
        $( window ).on( 'scroll', function ( e ) {

            if ( $( this ).scrollTop() > 250 ) {
                $(wpiris_fade).addClass( 'backtotop--show' );
            } else {
                $(wpiris_fade).removeClass( 'backtotop--show' );
            }
        } );


        $(wpiris_fade).click(function () {
            $('body,html').animate({
                scrollTop: 0
            }, 600);
            return false;
        });
    }

    /* Initialize Insta Wall
    /* ============================================= */
    static initialize_instagram() {

        let $wrapper = $('[data-instagram-wall]');

        if ($wrapper.length > 0) {
            self = this;
            $.ajax({
                url: Theme.ajaxURL,
                data: {
                    'action': 'social_wall',
                },
                type: 'POST',
                success: function (socialData) {
                    $wrapper.append(socialData);
                }
            });
        }
    }

    /* Burger menu
    /* ============================================= */
    static initialize_burger_menu() {

        let incr = 0;
        const burger = '[data-trigger="burger-menu"]',
            navbar = '[data-trigger="navbar"]',
            logo = '[data-id="wpiris-logo"]',
            logo_src = $(logo).attr("src");

        $(burger).on("click", function() {
            $(navbar).toggleClass( 'navbar-is-active' );
            $('.burgerMenu').toggleClass( 'burgerMenu-is-active' );
            if (incr%2 == 0) {
                $(logo).attr("src", Theme.themeURL + "/assets/dist/images/logo.svg");
            } else {
                $(logo).attr("src", logo_src);
            }
            incr++;
        })

        $('.menuMobileListItem').on("click", function() {
            $(this).toggleClass( 'menuMobileListItem-is-active' );
        })
    }
}
